/**
 * Check query params in the URL and populate matching filters with their values.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {HTMLElement} parent
 */
export function populateFiltersFromUrl(parent) {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const currentSearchParamString = currentSearchParams.toString();

    if (currentSearchParamString !== '') {
        currentSearchParams.forEach((value, key) => {
            const allValues = value.split('|');
            allValues.forEach((singleValue) => {
                const inputs = parent.querySelectorAll(`[name="${key}"], .wsf-form .ct-filter-${key}`);

                if (inputs) {
                    inputs.forEach((input) => {
                        switch (input.type) {
                            case 'checkbox':
                            case 'radio':
                                if (input.value === singleValue) {
                                    input.checked = true;
                                }
                                break;
                            default:
                                input.value = singleValue;
                                break;
                        }
                    });
                }
            });
        });
    }
}
